import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp12} ${props => props.theme.spacing.sp16};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  border-radius: ${props => props.theme.radius.card};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
